// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NppwWDKCa0Xo33JPiBkD p{margin:auto}`, "",{"version":3,"sources":["webpack://./src/app/catalog/product/components/product-list-item.component/style.module.scss"],"names":[],"mappings":"AACE,wBACE,WAAA","sourcesContent":[".product-list-item-description-container {\n  p {\n    margin: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product-list-item-description-container": `NppwWDKCa0Xo33JPiBkD`
};
export default ___CSS_LOADER_EXPORT___;
